import { db, TunnelPosition } from 'technical/db';

export const tunnelPositionSyncService = {
  async download(positions: TunnelPosition[]): Promise<void> {
    await db.tunnelPositions.bulkPut(positions);
  },

  async reset(): Promise<void> {
    await db.tunnelPositions.clear();
  },
};
